import script from "./ServiceListing.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceListing.vue?vue&type=script&setup=true&lang=js"

import "./ServiceListing.vue?vue&type=style&index=0&id=f866528a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f866528a"]])

export default __exports__